<template>
  <div class="content user-info" :class="{ 'user-info__electron': isElectron }">
    <ul class="tabs-wrap">
      <li
        v-for="item in navList"
        :key="item.component"
        @click="activeTab = item.component"
        :class="{ active: activeTab === item.component }"
      >
        {{ item.name }}
      </li>
    </ul>
    <div class="content-wrap">
      <keep-alive> <component :is="activeTab"> </component></keep-alive>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@saas/components/src/utils/event-bus";
import BasicInfo from "./components/BasicInfo";
import Account from "./components/Account.vue";
import Address from "./components/Address.vue";
export default {
  data: function () {
    return {
      navList: [
        { name: "基本信息", component: "BasicInfo" },
        { name: "账号安全", component: "Account" },
        { name: "收货地址", component: "Address" },
      ],
      activeTab: "BasicInfo",
      isElectron: window.isElectron,
    };
  },
  mounted() {
    EventBus.$off("user-info-page-change-tab");
    EventBus.$on("user-info-page-change-tab", (key) => {
      if (this.tabValList.includes(key)) {
        this.activeTab = key;
      }
    });
    const { tab } = this.$route.query;
    if (tab && this.tabValList.includes(tab)) {
      this.activeTab = tab;
    }
  },
  methods: {},
  components: {
    BasicInfo,
    Account,
    Address,
  },
  computed: {
    tabValList() {
      return this.navList.map((item) => item.component);
    },
  },
};
</script>

<style lang="scss" scoped>
.user-info {
  padding-top: 20px;
  padding-bottom: 20px;
  display: flex;
  flex-direction: column;
  .tabs-wrap {
    display: flex;
    padding: 10px;
    background: #ffffff;
    // border-bottom: 1px solid #ededed;
    // border-radius: 8px 8px 0 0;
    background: unset;
    border: none;
    li {
      padding: 10px;
      cursor: pointer;
      font-size: 14px;
      margin-right: 10px;
    }
    .active {
      position: relative;
      font-weight: 600;
      color: #0d1400;
      &::after {
        position: absolute;
        content: " ";
        display: block;
        left: 50%;
        bottom: -3px;
        transform: translateX(-50%);
        width: 12px;
        height: 3px;
        background: linear-gradient(132deg, #00eb81 0%, #00c89d 100%);
        border-radius: 3px;
      }
    }
  }
  .content-wrap {
    // background: #ffffff;
    // padding: 20px;
    display: flex;
    flex: 1;
    border-radius: 0 0 8px 8px;
  }
}
.user-info__electron {
  .tabs-wrap {
    background: unset;
    border: none;
  }
}
</style>
